import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PauseModel } from "../../cours/models/pause.model";
import { FormGroup } from "@angular/forms";
import { environment } from '../../../environments/environment';
import { CoursModel } from "../../cours/models/cours.model";

@Injectable()
export class PauseService {
    constructor(private http: HttpClient,
    ) {}

    save(pauseForm: FormGroup): Observable<any>  {
        console.log('save pause', pauseForm);
        //const pauseModel = new PauseModel(pauseForm);
        return new CoursModel().getResource('default', 'patch')
            .call(this.http, 'createOrUpdatePause', pauseForm, [])


    }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/services/pause.service.ts